/**
 * form-tab
 * form 怎么提供？
 * 1、store ?
 * 2、slot ?
 */
import FormTab from './form-tab.vue';

export default FormTab;
